// src/constants/invoiceReturnConstants.js
export const INVOICE_RETURN_FETCH_REQUEST = 'INVOICE_RETURN_FETCH_REQUEST';
export const INVOICE_RETURN_FETCH_SUCCESS = 'INVOICE_RETURN_FETCH_SUCCESS';
export const INVOICE_RETURN_FETCH_FAIL = 'INVOICE_RETURN_FETCH_FAIL';

export const INVOICE_RETURN_SCAN_REQUEST = 'INVOICE_RETURN_SCAN_REQUEST';
export const INVOICE_RETURN_SCAN_SUCCESS = 'INVOICE_RETURN_SCAN_SUCCESS';
export const INVOICE_RETURN_SCAN_FAIL = 'INVOICE_RETURN_SCAN_FAIL';

export const INVOICE_RETURN_PRINT_REQUEST = 'INVOICE_RETURN_PRINT_REQUEST';
export const INVOICE_RETURN_PRINT_SUCCESS = 'INVOICE_RETURN_PRINT_SUCCESS';
export const INVOICE_RETURN_PRINT_FAIL = 'INVOICE_RETURN_PRINT_FAIL';

export const INVOICE_RETURN_LOAD_RETURNS_REQUEST = 'INVOICE_RETURN_LOAD_RETURNS_REQUEST';
export const INVOICE_RETURN_LOAD_RETURNS_SUCCESS = 'INVOICE_RETURN_LOAD_RETURNS_SUCCESS';
export const INVOICE_RETURN_LOAD_RETURNS_FAIL = 'INVOICE_RETURN_LOAD_RETURNS_FAIL';

export const INVOICE_RETURN_SET_INVOICE = 'INVOICE_RETURN_SET_INVOICE';
export const INVOICE_RETURN_RESET = 'INVOICE_RETURN_RESET';
export const INVOICE_RETURN_CLEAR_ERROR = 'INVOICE_RETURN_CLEAR_ERROR';